import { useEffect, useRef, useState } from 'react'
import { deviceMenuItems } from './deviceLinks'

/**
 * "Open device" si "..." in panoul incidentului, langa tichet: aceleasi
 * legaturi ca celula Device din rand. Panoul e React (`td.rowDetails`), deci
 * sertarul isi tine singur starea - `ui/cellDropdowns` se uita numai la celule.
 */
export function DeviceLinks({ id, name, at }: { id: number; name: string; at?: string }) {
  const [open, setOpen] = useState(false)
  const holder = useRef<HTMLSpanElement>(null)
  const toggle = useRef<HTMLButtonElement>(null)
  const [device, ...rest] = deviceMenuItems(id, at)

  useEffect(() => {
    if (!open) return
    const away = (e: MouseEvent) => {
      if (!holder.current?.contains(e.target as Node)) setOpen(false)
    }
    document.addEventListener('click', away)
    return () => document.removeEventListener('click', away)
  }, [open])

  if (id < 1) return null

  return (
    <span className="incident-device-links">
      <a className="btn btn-xs btn-default incident-device-open" data-spa href={device!.href}>
        <i className="fas fa-desktop" aria-hidden="true"></i> Open device
      </a>
      <span
        ref={holder}
        className={'btn-group incident-device-menu' + (open ? ' open' : '')}
        onKeyDown={(e) => {
          if (e.key !== 'Escape' || !open) return
          setOpen(false)
          toggle.current?.focus()
        }}
      >
        <button
          ref={toggle}
          type="button"
          className="btn btn-xs btn-link incident-device-more"
          aria-haspopup="true"
          aria-expanded={open ? 'true' : 'false'}
          aria-label={`More for ${name}`}
          title="More for this device"
          onClick={() => setOpen((o) => !o)}
        >
          <i className="fas fa-ellipsis-h" aria-hidden="true"></i>
        </button>
        {open && (
          <ul className="dropdown-menu">
            {rest.map((i) => (
              <li key={i.key} className={i.key === 'card' ? 'incident-device-card' : undefined}>
                {i.key === 'card' && <span role="separator" className="divider" />}
                <a data-spa href={i.href} onClick={() => setOpen(false)}>
                  {i.label}
                </a>
              </li>
            ))}
          </ul>
        )}
      </span>
    </span>
  )
}
